import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "select-field" }
const _hoisted_2 = {
  key: 0,
  class: "select-field_title-label w-full text-center"
}
const _hoisted_3 = { class: "select-field__frame" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]

import { i18n } from '@/i18n';
import { ISelectOption } from '@/coreDomainsModule/table';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'SimpleSelectField',
  props: {
    selectedValue: {},
    options: {},
    selectFieldTitle: { default: '' },
    isBorder: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "d402be56": (_unref(borderSize))
}))

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;
const borderSize: string = props.isBorder ? '2px' : '0px';

//関数
const changeSelectValue = (event) => {
  emits('update:modelValue', (event.target as HTMLSelectElement).value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectFieldTitle)
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_unref(t)(props.selectFieldTitle)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("select", {
        class: "select-field_selection w-full h-full text-center",
        "data-testid": `select-area`,
        value: props.selectedValue,
        onChange: changeSelectValue
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
          return (_openBlock(), _createElementBlock("option", {
            key: option.value,
            value: option.value
          }, _toDisplayString(_unref(t)(option.label)), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_4)
    ])
  ]))
}
}

})